import { Box, BoxProps } from '@chakra-ui/react';

import { ArrowDir } from '../utils';
import { BG, EXTENSION_H, EXTENSION_OFFSET } from './constants';

const CurveSection = ({
  side,
  bgColor = BG,
  ...props
}: { side?: ArrowDir; bgColor?: string } & BoxProps) => (
  <Box
    position="relative"
    w="20%"
    h={`${EXTENSION_H}px`}
    ml={side === 'left' ? 'auto' : 0}
    {...props}
  >
    <Box position="absolute" w="100%" h="100%" bg={bgColor} zIndex={1} />
    <Box
      position="absolute"
      w="100%"
      h="100%"
      bg="white"
      zIndex={2}
      {...(side === 'left'
        ? {
            right: `${EXTENSION_OFFSET}px`,
            borderTopRightRadius: '12px',
            borderBottomRightRadius: '12px',
          }
        : {
            left: `${EXTENSION_OFFSET}px`,
            borderTopLeftRadius: '12px',
            borderBottomLeftRadius: '12px',
          })}
    />
  </Box>
);

export default CurveSection;
